import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enAuth from "./locales/en/auth.json";
import enBilling from "./locales/en/billing.json";
import enCommon from "./locales/en/common.json";
import enInstances from "./locales/en/instances.json";
import enLayout from "./locales/en/layout.json";
import enTemplates from "./locales/en/templates.json";
import enTools from "./locales/en/tools.json";
import ruAuth from "./locales/ru/auth.json";
import ruBilling from "./locales/ru/billing.json";
import ruCommon from "./locales/ru/common.json";
import ruInstances from "./locales/ru/instances.json";
import ruLayout from "./locales/ru/layout.json";
import ruTemplates from "./locales/ru/templates.json";
import ruTools from "./locales/ru/tools.json";

export const SUPPORTED_LANGUAGES = ["en", "ru"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

// One namespace per admin section, so section PRs never edit the same file.
export const NAMESPACES = [
  "common",
  "auth",
  "layout",
  "instances",
  "templates",
  "tools",
  "billing",
] as const;

const LANGUAGE_STORAGE_KEY = "nbts_admin_lang";

// Bundled rather than fetched: the admin is small, and Express serves the
// SPA from dist/ with a catch-all fallback that would answer locale URLs
// with index.html.
const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    layout: enLayout,
    instances: enInstances,
    templates: enTemplates,
    tools: enTools,
    billing: enBilling,
  },
  ru: {
    common: ruCommon,
    auth: ruAuth,
    layout: ruLayout,
    instances: ruInstances,
    templates: ruTemplates,
    tools: ruTools,
    billing: ruBilling,
  },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    fallbackLng: "en",
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    ns: [...NAMESPACES],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

function syncDocument(language: string) {
  document.documentElement.lang = language;
  document.title = i18n.t("layout:documentTitle");
}

i18n.on("languageChanged", syncDocument);
if (i18n.isInitialized) {
  syncDocument(i18n.resolvedLanguage ?? "en");
}

export default i18n;
